// extracted by mini-css-extract-plugin
export default {"tooltipProTip":"_tooltip_tooltipProTip__Vx8So","atlas-tooltip-inner":"_tooltip_atlas-tooltip-inner__39XAh"};